import React from "react";
import { Button } from "react-bootstrap";

const BackAddBtns = ({
  isCustom,
  onClickBack,
  onClickAdd,
  onClickAdd1,
  onClickReload,
  addBtnTxt,
  addBtnTxt1,
  isAddBtn,
  isDiabled,
  isRawLead,
  isClose,
}) => {
  return (
    <div className="back-add-btns-container flexEnd">
      <div className="other-btns">
        {isCustom || isAddBtn ? (
          <>
            {isCustom ? (
              <Button
                className="saveBtn"
                variant="outline-danger"
                onClick={onClickBack}
                style={{ padding: "13px 20px", background: "#fff" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-left-short small-icon"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                  />
                </svg>
                Back
              </Button>
            ) : null}
          </>
        ) : null}

        {onClickReload && (
          <Button
            className="saveBtn smallText reloadBtn"
            variant="danger"
            onClick={onClickReload}
            style={{
              padding: "15px 20px",
              background: "#31363F",
              border: "1px solid #31363F",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-clockwise small-icon"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
              />
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
            </svg>
            Reload
          </Button>
        )}
      </div>

      {isCustom || isAddBtn ? (
        <>
          {addBtnTxt ? (
            <Button
              className="saveBtn smallText"
              variant="danger"
              onClick={onClickAdd}
              style={{ padding: "15px 20px" }}
              disabled={isDiabled}
            >
              {!isRawLead && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus small-icon"
                  viewBox="0 0 16 16"
                  style={{ width: "15px", height: "15px", color: "#fff" }}
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                </svg>
              )}

              {addBtnTxt ? addBtnTxt : " Add New"}
            </Button>
          ) : null}

          {addBtnTxt1 ? (
            <Button
              className="saveBtn smallText"
              variant="danger"
              onClick={onClickAdd1}
              style={{ padding: "15px 20px" }}
            >
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus small-icon"
                viewBox="0 0 16 16"
                style={{ width: "15px", height: "15px", color: "#fff" }}
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg> */}
              {addBtnTxt1 ? addBtnTxt1 : " Add New"}
            </Button>
          ) : null}
        </>
      ) : null}

      {isClose ? (
        <Button
          // className="saveBtn smallText"
          variant="danger"
          onClick={isClose}
          // style={{ padding: "15px 20px" }}
        >
          X
        </Button>
      ) : null}

      {/* {isCustom || isAddBtn ? (
        <>
          {isCustom ? (
            <Button
              className="saveBtn"
              variant="outline-danger"
              onClick={onClickBack}
              style={{ padding: "13px 20px", background: "#fff" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-left-short small-icon"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                />
              </svg>
              Back
            </Button>
          ) : null}

          {addBtnTxt ? (
            <Button
              className="saveBtn smallText"
              variant="danger"
              onClick={onClickAdd}
              style={{ padding: "15px 20px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus small-icon"
                viewBox="0 0 16 16"
                style={{ width: "15px", height: "15px", color: "#fff" }}
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
              {addBtnTxt ? addBtnTxt : " Add New"}
            </Button>
          ) : null}
        </>
      ) : null}

      <Button
        className="saveBtn smallText reloadBtn"
        variant="danger"
        onClick={onClickReload}
        style={{
          padding: "15px 20px",
          background: "#31363F",
          border: "1px solid #31363F",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-arrow-clockwise small-icon"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
          />
          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
        </svg>
        Reload
      </Button> */}
    </div>
  );
};

export default BackAddBtns;
